import React, { Component } from 'react';
import './css/signin.css';
import './css/dashboard.css';
import Login from './components/login.js';
// import Signup from './components/signup.js';
import Setup from './components/setup.js';
import ResetPassword from './components/resetpassword.js';
import Dashboard from './components/dashboard/dashboard.js';
import Redirect from './components/redirect.js';
import { BrowserRouter, Route } from 'react-router-dom'
import PopUp from './components/dashboard/functions/popup.js';
import actions from './components/language/actions';
var ReactRedux = require('react-redux');

class App extends Component {

  render() {
    var reset = window.reset;
    if (reset) {
      window.history.pushState('', '', '/setup');
    }

    window.kyc = parseInt(window.kyc);

    const content = this.props.content;
    const switchLanguage = this.props.switchLanguage;

    return (
     <BrowserRouter>

     <div>
          <Route path="/" exact component={Login}/>
          <Route path="/dashboard" exact render={({match})=><Dashboard data={content} switchLanguage={switchLanguage} page={match}/>}/>
          <Route path="/setup" component={Setup}/>
          <Route path="/resetpassword" component={ResetPassword}/>
          <Route path="/emailverification" component={Redirect}/>
          <Route path="/dashboard/:name" render={({match})=><Dashboard data={content} switchLanguage={switchLanguage} page={match}/>}/>
          <PopUp />
      </div>

     </BrowserRouter>
    );
  }
}

module.exports = ReactRedux.connect(
  (state) => ({content: state.content}),
  (dispatch) => ({switchLanguage: (lang) => dispatch(actions.switchLanguage(lang))})
)(App);



// WEBPACK FOOTER //
// ./src/App.js